import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClientViewModel } from '../../models-views/client.view.model';
import { AppCommon } from '../../providers/app-common';
import { QuickAddService } from '../../services/quick-add.service';
import { VenueViewModel } from '../../models-views/venue.view.model';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@Component({
  selector: 'app-venue-add-poc',
  standalone: false,
  templateUrl: './venue-add-poc.component.html',
  styleUrl: './venue-add-poc.component.scss',
})
export class VenueAddPocComponent {
  @Input() data: any;
  @Input() venueID: any;
  @Input() isVisible = false;
  @Input() allPOCData: any[] = [];
  @Input() pocList: any;
  @Output() closeDrawer = new EventEmitter<boolean>();
  @Output() closeDrawerData = new EventEmitter<boolean>();
  venueForm: FormGroup;
  loggedInUser: any;
  countryCodeList: any = [];

  constructor(
    private fb: FormBuilder,
    private message: NzMessageService,
    private vm: VenueViewModel,
    private quickAddService: QuickAddService
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user;
    this.vm.VenueAddPocComponent = this;
    this.venueForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(255)]],
      email: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(255)],
      ],
      mobile_number: ['', [Validators.required, Validators.maxLength(20)]],
      country_code: [null, Validators.required],

      business_number: ['', [Validators.maxLength(20)]],
      country_code_business: [null],

      whatsapp_number: ['', [Validators.maxLength(20)]],
      country_code_whatsapp: [null],
    });

    this.vm.countryCodeList.subscribe((data) => {
      this.countryCodeList = data.results;
    });
    this.vm.getCountryCodeList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue && this.data) {
      let formData = {
        name: this.data.name || '',
        email: this.data.email || '',
        mobile_number: this.data.mobile_number || '',
        country_code: this.data.country_code || null,

        whatsapp_number: this.data.whatsapp_number || '',
        country_code_whatsapp: this.data.country_code_whatsapp || null,

        business_number: this.data.business_number || '',
        country_code_business: this.data.country_code_business || null,
      };

      this.venueForm.patchValue(formData);
    }
  }

  handleCancel(): void {
    this.isVisible = false;
    this.venueForm.reset();
    this.closeDrawer.emit(false);
  }

  save(): void {
    if (this.venueForm.invalid) {
      this.message.error('Please fill all required fields correctly');
      return;
    }

    const formData = {
      ...this.venueForm.value,
      created_by: this.data ? undefined : this.loggedInUser.id,
      modified_by: this.data ? this.loggedInUser.id : undefined,
      venue: this.venueID,
    };

    if (this.data && this.venueID) {
      formData.modified_by = this.loggedInUser.id;
      formData.venue = this.venueID;

      this.vm.updatePOC(formData, this.data.id, 'venueAddPocComponent');
    } else if (this.venueID) {
      formData.created_by = this.loggedInUser.id;
      formData.venue = this.venueID;

      let pocDetails: any[] = [];

      if (Array.isArray(this.allPOCData)) {
        // allPOCData is already an array of POCs
        pocDetails = this.allPOCData;
      } else if (
        this.allPOCData &&
        typeof this.allPOCData === 'object' &&
        'vendor_details' in this.allPOCData
      ) {
        pocDetails = (this.allPOCData as any).vendor_details?.poc_details ?? [];
      } else {
        pocDetails = [];
      }

      if (this.pocList.some((el: any) => el.is_primary === true)) {
        formData.is_primary = false;
      } else {
        formData.is_primary = true;
      }

      this.vm.createPOC(formData);
    } else {
      this.pocCreated();
    }
  }

  pocUpdated() {
    let d = this.venueForm.value;
    d['id'] = this.data.id;
    this.closeDrawerData.emit(d);
    this.isVisible = false;
    this.venueForm.reset();
    this.quickAddService.refreshData.next(true);
    this.closeDrawer.emit(true);
  }

  pocCreated() {
    this.closeDrawerData.emit(this.venueForm.value);
    this.isVisible = false;
    this.venueForm.reset();
    this.quickAddService.refreshData.next(true);
    this.closeDrawer.emit(true);
  }
}
